import React, { useState } from 'react';
import './HelpCenter.css';

import { PageTitle, FaqItem, ProjectTabs } from '../../../components';
import { support } from '../../../constants';



const HelpCenter = () => {

  // Extract category names from supportFAQs
  const categories = Object.keys(support);

  // Default category state
  const [category, setCategory] = useState(categories[0]);

  // State to manage the active accordion
  const [activeAccordionId, setActiveAccordionId] = useState(null);

  // Function to handle accordion click event
  const handleAccordionClick = (id) => {
    setActiveAccordionId((prevId) => (prevId === id ? null : id));
  };

  return (
    <>
      {/* Page title */}
      <PageTitle title={'Help Center'} page={'Help Center'} />

      <div className='help-center'>

        <section className='tab-info'>

          {/* Category Tabs */}
          <ul className="tab-buttons">
            {categories.map((item) => (
              <ProjectTabs
                key={item}
                id={item}
                title={item.replace(/([A-Z])/g, ' $1').trim()} // Format category name
                setSelected={() => setCategory(item)}
                active={category === item}
                Icon={true} // PortfolioTabs supports an icon prop
              />
            ))}
          </ul>

          {/* FAQ Content based on selected category */}
          <div className='tab-sections'>

            <div className='faq tab-section active'>
              {/* Faq Accordion container */}
              <div className='accordion-container'>
                {/* Filter and render FAQs based on selected category */}
                {support[category].map((faq) => (
                  <FaqItem
                    key={faq.question} // Unique key for React list rendering
                    id={faq.question} // FAQ ID
                    title={faq.question} // FAQ Question
                    content={faq.answer} // FAQ Answer
                    isActive={faq.question === activeAccordionId} // Check if the current FAQ is active
                    onAccordionClick={handleAccordionClick} // Click handler to toggle FAQ
                  />
                ))}
              </div>
            </div>

          </div>

        </section>

      </div>
    </>
  );
};

export default HelpCenter;
